import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  loading: false,
  labels: [],
  availableLabels: [],
  medias: [],
  error: {},
  customNumber: 0,
  canSubmitLabels: false,
  tooMuchCustom: false,
  total: 0,
});

export default {
  mutations,
  actions,
  getters,
  state,
};
